var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CChartLine',{attrs:{"datasets":_vm.defaultDatasets,"options":_vm.defaultOptions,"labels":['1/9','2/9','3/9','4/9','5/9','6/9','7/9','8/9','9/9','10/9','11/9','12/9','13/9','14/9','15/9']}})}
var staticRenderFns = []

export { render, staticRenderFns }